import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import * as config from "./i18nConfig";
import { TranslationLoader } from "./plugins/translationLoader";
import type { AppLocale } from "./types";

const translationLoader = TranslationLoader();

export async function changeLanguage(appLocale: AppLocale) {
  await i18n.changeLanguage(appLocale);
}

export const init = async () => {
  await i18n
    .use(translationLoader)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: config.fallback,
      keySeparator: config.keySeparator,
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
      compatibilityJSON: "v4",
      supportedLngs: ["en", "es", "de", "sk"],
    });
};

export const getLocale = () => i18n.language as AppLocale;
export const t = i18n.t;
export type TFunction = typeof t;
